// the set of drawing tools exposed in the toolbar - PEN/RECT/DIAMOND/CIRCLE/LINE/ARROW/TEXT create
// shapes, SELECT lets the student move/resize/delete an existing shape
const TOOLS = {
	SELECT: 'select',
	PEN: 'pen',
	RECT: 'rect',
	DIAMOND: 'diamond',
	CIRCLE: 'circle',
	LINE: 'line',
	ARROW: 'arrow',
	TEXT: 'text'
};

// tools that are drawn by a click-drag-release gesture with a bounding box (as opposed to
// PEN, which free-follows the pointer, or TEXT, which is placed on a single click)
const BOX_TOOLS = [TOOLS.RECT, TOOLS.DIAMOND, TOOLS.CIRCLE, TOOLS.LINE, TOOLS.ARROW];

const DEFAULT_STROKE = '#364651';
const DEFAULT_STROKE_WIDTH = 2;
const DEFAULT_FONT_SIZE = 16;

// shared by the Konva Text node and the in-place label editor, so editing doesn't visibly shift the text
const LABEL_FONT_FAMILY = 'Arial';
const LABEL_LINE_HEIGHT = 1.2;

const GRID_SIZE = 20;
const GRID_COLOUR = '#d0d0d0';

const MIN_SHAPE_SIZE = 4;

export {
	TOOLS,
	BOX_TOOLS,
	DEFAULT_STROKE,
	DEFAULT_STROKE_WIDTH,
	DEFAULT_FONT_SIZE,
	LABEL_FONT_FAMILY,
	LABEL_LINE_HEIGHT,
	GRID_SIZE,
	GRID_COLOUR,
	MIN_SHAPE_SIZE
}
